import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  openCustomSnackbar(data: { icon: boolean;  message: string; className:string;}) {
    
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: data,
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: [data.className],
    });
  }
}
